export default {"src":"/_next/static/media/icon-info.78e71f31.svg","height":16,"width":16};